import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ChangePasswordRequest } from '@uw/core/api/models';
import { AuthService } from '@uw/core/services/auth.service';
import { Subject, of, catchError, map, startWith, switchMap } from 'rxjs';
import { ChangePasswordFormComponent } from '../../components/change-password-form/change-password-form.component';
import { AsyncPipe } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';



@Component({
    selector: 'uw-change-password',
    templateUrl: './change-password.component.html',
    styleUrls: ['./change-password.component.scss'],
    imports: [ChangePasswordFormComponent, AsyncPipe, TranslateModule]
})
export class ChangePasswordComponent {

  private _saveSubject = new Subject<ChangePasswordRequest>();
  buttonLoading = false;

  // readonly form = new UntypedFormGroup({
  //   currentPassword: new UntypedFormControl(null, [Validators.required]),
  //   newPassword: new UntypedFormControl(null, [Validators.required,
  //     Validators.pattern(/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9]).{12,16}$/)]),        
           
  //   confirmPassword: new UntypedFormControl(null, [Validators.required]),
  // });

  readonly vm$ = this._saveSubject.pipe(
    switchMap(request => this._authService.changePassword(request).pipe(      
      catchError(err => {
        let errorMessage =
            err && err.message && err.message == 'cannot_reuse_password'
              ? 'change_password.error.code.cannot_reuse_password'
                 : (err.message == 'Incorrect password.' ? 'change_password.error.code.incorrect_password' :
                'messages.password_update_failed');
        return of({errorMessage, passwordChanged: false});
      })
    )),
    map( resp => { 
      this.buttonLoading = false;
      if (resp.errorMessage) {
        return resp;
      } else {
        return {passwordChanged: true, errorMessage: null };
      }
      
    }),
    startWith({ passwordChanged: false, errorMessage: null }),
    
  )

  constructor(
    private readonly _authService: AuthService
  ) { }

  save(request: ChangePasswordRequest) {
    this.buttonLoading = true;
    this._saveSubject.next(request);
  }

  showPassword(passwordControl: any) {
    if (passwordControl.type === "password") {
      passwordControl.type = "text";
    } else {
      passwordControl.type = "password";
    }
  }
}
